<template>
  <div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
          <b-tab title="Customer Generation" border-variant="primary" >
            <b-card border-variant="primary">
              <div slot="header">
                <strong>Group Info</strong>
                <span class="float-right">{{model.joined_at | datetime}}</span>
              </div>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_name">Group Name(*)</label>
                    <b-form-input md=12 type="text" id="ph_name" v-model="model.groupname" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
                <!-- {{partner_service}} -->
                <b-col md="6">
                  <b-form-group>
                    <h5 class="text-center mt-0">
                      <small>
                        Usage Solution
                        (<b-button variant="link" @click="index = 3" class="px-0">Install History</b-button>)
                      </small>
                      <br>
                      <b-badge class="mt-4" variant="danger">WebCastle : {{model.info.wc_count}} </b-badge>
                      <b-badge class="mt-4" variant="warning">WSFinder : {{model.info.wsf_count}} </b-badge>
                      <b-badge class="mt-4" variant="success">WMDS : {{model.info.wmds_count}} </b-badge>
                      <b-badge class="mt-4" variant="info">WFDetector : {{model.info.wf_count}} </b-badge>
                    </h5>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <b-form-group>
                    <label for="ph_service" v-b-tooltip.hover title="Service">Service(*)</label>
                    <v-select :readonly="true" @input="set_service" v-if="!lock || !model.service_name" label="service_name" v-model="model.service" :options="partner_service"></v-select>
                    <h4 v-else>
                      <b-badge  :variant="model.service_name === 'Basic' ? 'info' : 'success'"> {{model.service_name}} </b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Credit" label-for="ph_credit"
                    v-b-tooltip.hover title="Credit">
                    $ {{model.credit | number}}
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Member's" label-for="ph_count"
                    v-b-tooltip.hover title="Verified Allow login.">
                    {{model.count | number}}
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Invoice" v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
                    <c-switch :disabled="lock" color="info" label size="sm" v-model="model.allow_invoice"/>
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Active" label-for="ph_is_alive"
                    v-b-tooltip.hover title="Verified Allow login.">
                    <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Delete" label-for="ph_delete"
                    v-b-tooltip.hover title="delete status">
                    <c-switch color="danger" label size="sm" v-model="model.is_del" :disabled="true" />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Mail" label-for="ph_mail"
                    v-b-tooltip.hover title="allow Notice alert mail(Detect, QNA, Notice, etc...)">
                    <c-switch color="info" label size="sm" v-model="model.allow_mail" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Single login" label-for="ph_single_login"
                    v-b-tooltip.hover title="single login Allow login.">
                    <c-switch color="info" label size="sm" v-model="model.single_login" :disabled="lock" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_email" v-b-tooltip.hover title="Email">E-mail(*)</label>
                    <b-form-input type="text" id="ph_email" :value="model.email" v-model="model.email" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="contact" label-for="ph_contact" v-b-tooltip.hover title="contact.">
                    <b-form-input type="text" id="ph_contact" :value="model.contact" v-model="model.contact" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="group_address">Address(*)</label>
                    <b-form-input md=12 type="text" id="group_address" v-model="model.address" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <h4>Region</h4>
              <hr>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_country_group" v-b-tooltip.hover title="country">Country(*)</label>
                    <v-select :readonly="true" @input="set_country" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_language_group" v-b-tooltip.hover title="language">language(*)</label>
                    <v-select :readonly="true" @input="set_language" :disabled="lock" label="name" v-model="region.language" :options="codes.language"></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
                    <v-select :readonly="true" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col>
                  <b-form-group>
                    <label for="ph_syslog" v-b-tooltip.hover title="Enter a syslog server ip, ex) 192.168.0.100, 192.168.0.0/24 "><h4>Syslog</h4></label>
                    <b-form-textarea ref="syslog_list" :rows="model && model.syslog ? model.syslog.length + 2 : 0" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label for="ph_mail_cc" v-b-tooltip.hover title="Enter a email address for detect alert reference cc"><h4>Email CC</h4></label>
                    <b-form-textarea ref="email_cc_list" :rows="model && model.mail_cc ? model.mail_cc.length + 2 : 0" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-button :disabled="model.is_del" v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
              <b-button :disabled="model.is_del" v-else size="sm" variant="warning" @click="edit">Edit </b-button>
              <b-button :disabled="model.is_del" v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button>
              <b-button :disabled="model.is_del" size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock"> Remove </b-button>
              <b-button size="sm" variant="primary" @click="send_ip_reset_mail" v-if="model.id"> Send IP ACL Reset Mail </b-button>
              <span v-if="model.is_del">was deleted</span>
              <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>

              <!-- start partner info -->
              <!-- <b-button v-if="!syncPartner && !lock" size="sm" variant="warning" @click="chainPartner = true">
                {{model.partner ? 'Change' : 'Connect'}} Partner
              </b-button> -->
              <!-- <b-button :disabled="!model.id" v-if="$route.params.id != 'add' && syncPartner && lock" variant="success" @click="partnerSave()"> apply </b-button> -->
              <!-- end partner info -->
              <hr>
              <partner-Detail v-if="model.partner_id && model.partner && !model.partner.is_del" :partner="model.partner"></partner-Detail>
            </b-card>
          </b-tab>
          <!-- start group's user -->
          <b-tab title="Group's User list" border-variant="primary" :disabled="$route.params.id == 'add'">
            <!-- start group's user -->
            <user-list v-if="model.id" :group="model" :view_detail="false"/>
          </b-tab>
          <!-- end group's user -->

          <!-- start group's security_policy -->
          <b-tab title="Security policy" border-variant="primary" :disabled="$route.params.id == 'add'">
            <security-policy v-if="model.id" :group="model"/>
          </b-tab>
          <!-- end group's security_policy -->

          <!-- start group's user -->
          <!-- <b-tab title="WSFinder" border-variant="primary" >
            <wsfinder-list v-if="model.id && model.service != 'Basic'" :group="model" :delay="2"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's user -->
          <!-- <b-tab title="WMDS" border-variant="primary" >
            <wmds-list v-if="model.id" :group="model" :delay="3"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's user -->
          <!-- <b-tab title="WebCastle" border-variant="primary" >
            <webcastle-list v-if="model.id" :group="model" :delay="4"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's install history -->
          <b-tab title="Install History" :disabled="$route.params.id == 'add'" @click="() => $refs.install_history ? $refs.install_history.refresh() : ''">
            <InstallHistoryList ref="install_history" :user="model" />
          </b-tab>
          <!-- end group's install history -->
          <!-- start group's Invoice -->
          <b-tab title="Invoice" :disabled="$route.params.id == 'add'" @click="() => $refs.install_history ? $refs.install_history.refresh() : ''">
            <!-- ss -->
            <InvoiceHistoryList v-if="model.id" :group_id="model.id" ref="_list_invoice" />
            <hr>
            <b-button size="sm" variant="dark" @click="confirm_ticket_invoice = true;" v-if="model.id"> Ticket Invoice </b-button>
          </b-tab>
          <!-- end group's Invoice -->
          <!-- start group's Invoice -->
          <b-tab title="QNA" :disabled="$route.params.id == 'add'" @click="() => $refs.install_history ? $refs.install_history.refresh() : ''">
            <!-- user == group -->
            <QNAList v-if="model.id" :group="model" :only_view="true" />
          </b-tab>
          <!-- end group's Invoice -->
        </b-tabs>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      Would You Like to Remove the group?
    </b-modal>
    <b-modal size="xl" title="Find and select Partner"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-variant="info">
      <Partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></Partner-List>
    </b-modal>
    <!-- 인보이스 발급 년월 선택 -->
    <b-modal title="Ticket Invoice"  class="modal-dark" v-model="confirm_ticket_invoice" @ok="ticket_invoice" ok-variant="dark">
      <b-form-group>
        <p>please select the month of invoice</p>
        <hr>
        <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month"> </vue-monthly-picker>
        <!-- <date-picker format="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker> -->
        <hr>
        <small class="text-danger font-weight-bold">
          If it's already issued, force it to be issued.
          <br>
          Please check the amount of invoice generated.
          <br>
          An information mail will be sent when the invoice is issued.
        </small>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';
import reg from '@/reg';
import PartnerDetail from '../partner/Partner.Detail';
import PartnerList from '../partner/Partner.List';
import UserList from '../user/User.List';
import wsfinderList from '../../WSFinder/agent/Agent.List';
import wmdsList from '../../WMDS/site/Site.List';
import webcastleList from '../../WebCastle/modules/Modules.List';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as _ from 'lodash';
import SecurityPolicy from './SecurityPolicy';
import InstallHistoryList from '@/views/History/install/Install.List'
import InvoiceHistoryList from '@/views/Billing/invoice.group/Invoice.List'
import QNAList from '@/views/Board/qna/QNA.List'

import DatePicker from 'vue2-datepicker'
import VueMonthlyPicker from 'vue-monthly-picker'
import custom from '@/custom';
import moment from 'moment-timezone'

const default_model = () => (
  { service : codes.service_default, allow_mail : true, is_alive : true }
);

export default {
  components: {
    VueMonthlyPicker,
    QNAList,
    DatePicker,
    InvoiceHistoryList,
    InstallHistoryList,
    SecurityPolicy,
    PartnerList,
    wsfinderList,
    wmdsList,
    webcastleList,
    UserList,
    cSwitch,
    vSelect,
    PartnerDetail
  },
  data : () => {
    return {
      ticket_invoice_month : '',
      custom,
      confirm_ticket_invoice : false,
      index : 0,
      partnerOpt : ["username", "nickname"],
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'username', sv: '', skt: 'username', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : Object.assign(default_model(), { info : { wc_count : 0, wsf_count : 0, wf_count : 0, wmds_count : 0 }, email_cc : [] }),
      lock : true,
      codes,

      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      partner_service : []
    }
  },
  computed: {
    fields() {
      return [
        { key: 'username', sortable: true, label: 'E-mail'},
        { key: 'nickname', sortable: true, label: 'Name' },
        { key: 'last_visit', label: 'Last_visit', sortable: true },
        { key: 'func', label: 'Select', sortable: false },
    ]}
  },
  methods: {
    async send_ip_reset_mail() {
      let rs = await Api.Manager_Call('group', 'mail.ip.reset', { group_id : this.model.id });
      return rs.is_error ? this.$toastr.e("Sending IP ACL Reset Mail", "failed") : this.$toastr.s("IP ACL Reset Mail", "Sented");
    },
    // 매니저의 강제 인보이스 발급
    ticket_invoice() {
      if(moment(this.ticket_invoice_month).add(-1, 'month').diff(moment(), 'month') >= 0) {
        return this.$toastr.w("Future cannot issue invoice")
      } else if(!this.ticket_invoice_month) {
        return this.$toastr.w("plz, select date")
      }
      console.log(this.ticket_invoice_month.format("yyyy-MM-DD"))
      let body = {
        target : 'invoice', cmd : 'ticket',
        body : {
          group_id : this.model.id,
          month : this.ticket_invoice_month.format("yyyy-MM-DD")
        }
      }

      return Api.Manager(body)
        .then(rs => {
          if(rs.error) { return this.$toastr.w("failed ticket invoice") }
          this.$refs ? this.$refs._list_invoice.refresh() : ''
          this.$emit('refresh')
          rs.error ? this.$toastr.w("failed ticket invoice") : this.$toastr.i("created invoice")
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    load_partner_service() {
      try{
       let partner_service_info = {
          target : 'partner.license', cmd : 'list',
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '=' }, { name : 'is_alive', value : true, op : '=' }] }
        }
        // 파트너와 함께 그룹 생성할 경우
        if(this.$route.params.tag == "partner") {
          console.log("load partner's service")
          partner_service_info.body.and.push({ name : 'partner_id', value : Number(this.$route.params.id), op : '=' })
        }

        // 그룹을 직접 생성할 경우
        if(this.$route.params.id == "add") {
          console.log("load partner's service")
          partner_service_info.body.and.push({ name : 'partner_id', value : 1, op : '=' })
        } else {
          // 파트너 서비스 로드
            partner_service_info.body.and.push({ name : 'partner_id', value : this.model.partner_id, op : '=' })
        }


        // if(this.$route.params.id && !this.$route.params.tag) {
        //   console.log("load partner's service")
        //   partner_service_info.body.and.push({ name : 'partner_id', value : this.model.partner_id, op : '=' })
        // }

        // console.log(partner_service_info)

        Api.Manager(partner_service_info).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }

          rs.body.forEach(x => {
            if(!x.is_publish) {
              return console.log('not puglished', x.service_name)
            }
            if(this.model.service_id == x.id) {
              // 자기 서비스 찾아서 넣기
              this.model = Object.assign({}, this.model, { service : x })
              console.log('updated service', x.service_name)
            }
            this.partner_service.push({ service_name : x.service_name, id : x.id })
          })

          this.model.service.service_name = this.partner_service[this.partner_service.length - 1].service_name
          this.model.service.value = this.partner_service[this.partner_service.length - 1].id

          // if(!this.model.service_name) { this.model.service_name = this.partner_service[this.partner_service.length - 1].name }

        }).catch(e => this.$toastr.e(e.data.message, e.status, e.statusText))
      } catch(e) { console.log(e); this.$toastr.e(e.data.message, e.status, e.statusText); }
    },
    edit:function() { this.lock = false },
    set_service:function(x) { if(!x) { return; } this.model.service_id = x.id },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
      this.$emit('refresh')
    },
    list: function() { this.$router.push({ name: 'group' }); this.$emit('refresh'); },
    remove: function() {
      this.model.is_del = true;
      if(this.model.count) { this.$toastr.w('User exists', 'Warning'); return; }
      Api.Manager_Call('group', 'delete', { id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list();
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    getRowCount () { return this.so.totalRows || 0; },
    loadPartner() {
      // if(!this.so.sv) { return console.log("open modal") }
      let so = {
        target : 'partner', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(this.so.sv) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }) }

      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    setPartner(item) {
      this.model.partner = item;
      this.chainPartner = false;
      if(this.$route.params.id == "add") { this.model.partner_id = item.id; }
      this.syncPartner = true;
      this.$toastr.i("please apply your change", "done")
    },
    async partnerSave() {
      try {
        this.model.partner_id = this.model.partner.id;

        let rs = await Api.Manager_Call('group', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id);
        } else {
          this.$toastr.e('Save', "failed"); this.refresh();
        }
        this.syncPartner = false;
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(this.model.service == ''|| this.model.service == undefined) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        // set region
        if(!this.region.country) { return this.$toastr.e('Country Required.'); }
        if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
        if(!this.region.language) { return this.$toastr.e('Language Required.'); }

        if(this.$route.params.tag == "partner" && Number(this.$route.params.id) > 0) { this.model.partner_id = Number(this.$route.params.id) }

        let model = this.model;

        if(this.partner) { model.partner_id = this.partner.parent_id ? this.partner.parent_id : this.partner.id }

        if(this.model.syslog_list) {
          model.syslog = _.uniq(_.compact(this.model.syslog_list.replace(/,/gm, '').split("\n")));
          // b-form-textarea has bug, can not bind model so rirect update
          this.model.syslog_list = _.join(model.syslog, '\n')
          this.$refs.syslog_list.localValue = _.join(model.syslog, '\n')
        }

        if(this.model.email_cc_list) {
          model.email_cc = _.uniq(_.compact(this.model.email_cc_list.replace(/,/gm, '').split("\n")));
          // b-form-textarea has bug, can not bind model so rirect update
          this.model.email_cc_list = _.join(model.email_cc, '\n')
          this.$refs.email_cc_list.localValue = _.join(model.email_cc, '\n')
        }

        let region = {};
        region.country = this.region.country.value
        region.language = this.region.language.value
        region.timezone = this.region.timezone.value

        let service = this.model.service.service_name ? this.model.service.service_name : this.model.service
        // let service_id = this.model.service.service_name ? this.model.service.id : 0

        let rs = await Api.Manager_Call('group', this.model.id ? 'update' : 'insert', Object.assign({}, this.model, model, region, { service : service }));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.lock = true;
        this.refresh(rs.body.id)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()}
    },
    get: async function({ id, tag } = this.$route.params) {
      if(tag == 'partner') {
        try {
          this.passPartner = true;
          let rs = await Api.Manager_Call('partner', 'detail', { id : id })

          this.model.partner = Object.assign({}, this.model.partner, rs.body)
          this.model.partner_id = this.model.partner.id;
          this.passPartner = false;

        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
      }
      console.log('group.detail.vue', 'load item', 'id', id, 'tag', tag);
      if(id === 'add' || tag === 'partner') { this.model.is_verified = true; this.add = (tag != 'partner'); this.lock = false; return this.load_partner_service(); }
      else {
        Api.Manager_Call('group','detail',{ id : id }).then(rs => this.model = Object.assign({ group: {} }, this.model, rs.body))
        .then(() => {

          this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")
          this.model = Object.assign({}, this.model, { syslog_list : this.model.syslog && this.model.syslog.join("\n"), email_cc_list : this.model.email_cc && this.model.email_cc.join("\n") } )

          let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

          let is_done_language = false;
          codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

          if(!this.model.service_name) { this.model.service_name = this.model.service }

          this.load_partner_service()
          this.load_using_status()

        }).catch(e => {console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()});
      }
    },
    refresh(id) { id ? this.$router.push({ name: 'group', params : { id : id ? id : this.$route.params.id } }) :  this.$emit('refresh'); },
    load_using_status() {
        Api.Manager_Call('group', 'info', { group_id : this.model.id  }).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }
          this.model.info = Object.assign({}, this.model.info, rs.body)
        }).catch(e => this.$toastr.e(e.data.message, e.status, e.statusText))
    },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('group.detail.vue', 'created'); },
  destroyed: function() { console.log('group.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('group.detail.vue', 'mounted');
    this.get(this.$route.params);

  },
}
</script>
